import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

/**
 * Shared section styles for the order form components. Each section
 * renders as a distinct card — own background, rounded corners, and
 * subtle border — so the 2-column layout reads as separate inset
 * blocks rather than a continuous flat stack.
 */
export const useOrderSectionStyles = makeStyles({
  section: {
    ...shorthands.padding('20px', '24px'),
    ...shorthands.border('1px', 'solid', tokens.colorNeutralStroke2),
    ...shorthands.borderRadius('6px'),
    backgroundColor: tokens.colorNeutralBackground1,
  },
  sectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '16px',
  },
  sectionTitle: {
    fontSize: '16px',
    fontWeight: '600',
    display: 'flex',
    alignItems: 'center',
    ...shorthands.gap('8px'),
    '& svg': {
      color: tokens.colorNeutralForeground2,
      flexShrink: 0,
    },
  },
});
